/**
 * Notifications Page
 *
 * Notification preferences for email, push, and in-app notifications.
 * Delegates to ConnectedNotificationsModule from @bloomcode/shared-modules.
 */

import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@bloomcode/ui';
import { ConnectedNotificationsModule, MetaTags } from '@bloomcode/shared-modules';

export default function NotificationsPage() {
  return (
    <>
      <Helmet>
        <title>Notifications - Bloomcode Account</title>
      </Helmet>
      <MetaTags title="Notification Settings" description="Manage your notification preferences" />
      <div className="container mx-auto px-4 py-8">
        <Breadcrumb className="mb-4">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Notifications</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <ConnectedNotificationsModule />
      </div>
    </>
  );
}
